import { logger } from './logger';
import { MfsStatusCode, logVerbose } from '@metaos/mfs-telemetry';
import { ConnectionState } from '@fluidframework/container-loader';
/**
 * Logs an error
 *
 * @param eventName Unique event name that causes an error
 * @param message Text message to identify an error
 * @param unknownError Caught object from a catch statement
 */
export function logError(eventName, message, unknownError) {
    logVerbose(logger, 'logError', () => {
        const error = unknownError instanceof Error ? unknownError : undefined;
        logger.logError(eventName, MfsStatusCode.ExpectationFailed, { message: message, error }, 'logError');
    });
}
/**
 * Disconnects a container if it can be disconnected. No action will be taken if a container has been closed or is
 * already in disconnected state.
 *
 * @param container Container to disconnect
 */
export function disconnectContainer(container) {
    logVerbose(logger, 'disconnectContainer', () => {
        try {
            if (canDisconnectContainer(container)) {
                container.disconnect();
                logger.logInfo('containerDisconnected', 'Container was disconnected', 'disconnectContainer');
            }
        }
        catch (unknownError) {
            logError('containerDisconnectError', 'Error disconnecting container', unknownError);
        }
    });
}
/**
 * Checks if a container can be disconnected
 *
 * @param container Container to check
 */
function canDisconnectContainer(container) {
    return logVerbose(logger, 'canDisconnectContainer', () => {
        return !container.closed && container.connectionState !== ConnectionState.Disconnected;
    });
}
/**
 * Connects a container if it can be connected. No action will be taken if a container has been closed, or if it's not
 * in disconnected state.
 *
 * @param container Container to connect
 */
export function connectContainer(container) {
    return logVerbose(logger, 'connectContainer', () => {
        try {
            if (canConnectContainer(container)) {
                container.connect();
                logger.logInfo('containerConnected', 'Container was reconnected', 'connectContainer');
            }
        }
        catch (unknownError) {
            logError('containerConnectError', 'Error connecting container', unknownError);
        }
    });
}
/**
 * Checks if a container can be connected
 *
 * @param container Container to check
 */
function canConnectContainer(container) {
    return logVerbose(logger, 'canConnectContainer', () => {
        return !container.closed && container.connectionState === ConnectionState.Disconnected;
    });
}
//# sourceMappingURL=utility.js.map